import { clearRoleAssumption, HostActions, saveRoleAssumptionUserName } from '@makemydeal/dr-activities-role-assumption';
import * as roleAssumptionActionCreators from '@makemydeal/dr-dash-store/actions/roleAssumptionActionCreators';

export const hostActions: HostActions = {
    navigateToDashboard: () => roleAssumptionActionCreators.navigateToDashboard(),

    // Remove role assumption user details from session storage
    clearRoleAssumption: () => clearRoleAssumption(),

    // Store role assumption user details in session storage
    saveRoleAssumptionUserName: (username) => saveRoleAssumptionUserName(username)
};
